"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const firebase_1 = __importStar(require("../auth/firebase"));
const userInfo_1 = __importDefault(require("../auth/userInfo"));
const user_1 = require("../store/selectors/user");
const user_2 = require("../slices/user");
const useAuth = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    const userId = (0, react_redux_1.useSelector)(user_1.selectUserId);
    const authToken = (0, react_redux_1.useSelector)(user_1.selectAccessToken);
    const isUserLogged = (0, react_1.useMemo)(() => Boolean(fbUser), [fbUser]);
    const refreshToken = (0, react_1.useCallback)(async () => {
        if (fbUser) {
            try {
                const newToken = await (0, firebase_1.getRefreshedUserToken)();
                if (newToken) {
                    dispatch((0, user_2.setAuthToken)(newToken));
                }
            }
            catch (error) {
                console.error("Failed to refresh token:", error);
            }
        }
    }, [fbUser, dispatch]);
    (0, react_1.useEffect)(() => {
        userInfo_1.default.userId = userId ?? '';
        userInfo_1.default.authToken = authToken;
        const TOKEN_EXPIRATION_TIME = 3600000; // 1 hour
        const BEFORE_EXPIRATION_TIME = 300000; // 5 minutes
        const refreshInterval = setInterval(refreshToken, TOKEN_EXPIRATION_TIME - BEFORE_EXPIRATION_TIME);
        return () => clearInterval(refreshInterval);
    }, [userId, authToken, refreshToken]);
    const getAuthStatus = (0, react_1.useCallback)(() => (Boolean(fbUser?.uid)), [fbUser?.uid]);
    return {
        authUser: fbUser,
        getAuthStatus,
        auth: firebase_1.default,
        webAuth: firebase_1.default,
        isUserLogged,
        refreshToken,
    };
};
exports.useAuth = useAuth;
